import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const reinviteInternalOrganizationUserApi = async (
  userId: string
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/internal/users/${userId}/resend-invitation/`;

  return authApiService.POST(uri, {});
};
